var modals = {
  init: function () {
    $("body").on("click", ".modal-trigger", function (e) {
      e.preventDefault();

      var target = $(this).attr("data-target");
      var modalContent = $(target);

      modalContent.addClass("product-modal-wrapper");

      $("body").append(modalContent);
    });

    $(document).mouseup(function (e) {
      var container = $(".product-modal__content");

      if (!container.is(e.target) && container.has(e.target).length === 0) {
        $(".product-modal-wrapper").removeClass("product-modal-wrapper");
      }
    });

    $("body").on("click", ".product-modal__close", function () {
      $(".product-modal-wrapper").removeClass("product-modal-wrapper");
    });
  },
  get_selected_values: function (target) {},
  close: function () {},
};

$(document).on(
  "change",
  ".quick-add-modal-form-addon__item select",
  function () {
    console.log(this.value);
    var op1 = $(this)
        .parents(".options")
        .find('select[data-opindex="1"]')
        .val(),
      op2 = $(this).parents(".options").find('select[data-opindex="2"]').val(),
      op3 = $(this).parents(".options").find('select[data-opindex="3"]').val();
    if (op1 == undefined) {
      op1 = "";
    }
    if (op2 == undefined) {
      op2 = "";
    }
    if (op3 == undefined) {
      op3 = "";
    }
    console.log(
      "opin " +
        op1.replace('"', "").replace('"', "") +
        " " +
        op2.replace('"', "").replace('"', "") +
        " " +
        op3.replace('"', "").replace('"', "")
    );
    var vid = $(this)
      .parents(".quick-add-modal-form-addon__item")
      .find(
        '.ops div[data-op1="' +
          op1.replace('"', "").replace('"', "") +
          '"][data-op2="' +
          op2.replace('"', "").replace('"', "") +
          '"][data-op3="' +
          op3.replace('"', "").replace('"', "") +
          '"]'
      )
      .data("vid");
    console.log("vid: " + vid);

    console.log(
      "was: " +
        $(this)
          .parents(".quick-add-modal-form-addon__item")
          .find("input")
          .data("vid")
    );
    $(this)
      .parents(".quick-add-modal-form-addon__item")
      .find("input")
      .data("vid", vid);
    console.log(
      "now is: " +
        $(this)
          .parents(".quick-add-modal-form-addon__item")
          .find("input")
          .data("vid")
    );
    $(this)
      .parents(".quick-add-modal-form-addon__item")
      .find(".quick-add-modal-form-addon-image img")
      .click();
    $(this)
      .parents(".quick-add-modal-form-addon__item")
      .find(".quick-add-modal-form-addon-image img")
      .click();
  }
);

$(document).ready(function () {
  modals.init();

  //FDR slider

  $(".fdr-step-col-list").slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 6,
    slidesToScroll: 6,
    prevArrow:
      '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><i class="far fa-angle-left"></i></button>',
    nextArrow:
      '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><i class="far fa-angle-right"></i></button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  });
  //FDR Tab navigate
  $(".fdr-step-col").on("click", function () {
    var dataCol = $(this).attr("data-col");

    $(".fdr-step-col").removeClass("active");
    $(this).addClass("active");

    $(".fdr-step-col-products").removeClass("active");
    $("#" + dataCol).addClass("active");
  });

  //additional options update
  $("body").on(
    "click",
    ".select-product-custom-product-item .first-option",
    function () {
      $(".select-product-custom-product-item").removeClass(
        "select-product-custom-product-item--showlist"
      );
      $(this)
        .closest(".select-product-custom-product-item")
        .addClass("select-product-custom-product-item--showlist");
    }
  );

  $("body").on(
    "click",
    ".select-product-custom-product-item .option",
    function () {
      var text = $(this).text();
      var parent = $(this).closest(".product-custom-selector__field");
      var title = parent.find(".customizer-option-title").text();
      var product_form = $(this).closest("form");

      product_form.find(`input[name="properties[${title}]"]`).remove();
      if (text == "None" || text == "Please select an option") {
        if ($(this).hasClass("option-product-custom-product-item")) {
          parent.find(".first-option").text(text);
          parent.attr("value", text);
          parent
            .find(".select-product-custom-product-item")
            .addClass("selected-product-custom");
          product_form.prepend(
            `<input type="hidden" name="properties[${title}]" value="${text}">`
          );
          parent.removeClass("not-valid");
        } else {
          parent.find(".first-option").text("Please select an option");
          parent.removeAttr("value");
          parent.removeAttr("data-count");
          parent
            .find(".select-product-custom-product-item")
            .removeClass("selected-product-custom");
          if (parent.hasClass("js-option-required")) {
            parent.addClass("not-valid");
          }
        }
      } else {
        parent.find(".first-option").text(text);
        parent.attr("value", text);
        parent
          .find(".select-product-custom-product-item")
          .addClass("selected-product-custom");
        product_form.prepend(
          `<input type="hidden" name="properties[${title}]" value="${text}">`
        );
        parent.removeClass("not-valid");
      }
      parent
        .find(".select-product-custom-product-item")
        .removeClass("select-product-custom-product-item--showlist");
    }
  );

  $(document).mouseup(function (e) {
    var container = $(".product-custom-dropdown");

    if (!container.is(e.target) && container.has(e.target).length === 0) {
      $(".select-product-custom-product-item").removeClass(
        "select-product-custom-product-item--showlist"
      );
    }
  });

  // valid fields
  $(".js-required-field").keyup(function () {
    var value = $(this).val();

    if (value == "") {
      $(this).addClass("not-valid");
    } else {
      $(this).removeClass("not-valid");
    }
  });

  // confirmation email
  $(".js-confirmation-email").on("keyup change", function () {
    var product_form = $(this).closest("form");
    var cEmail = $(this).val();
    var lEmail = product_form.find('[name="email"]').val();
    var cEmailWrap = $(this).closest(".quick-add-modal-form-field");

    $(".js-valide-email-label").remove();
    cEmailWrap.append('<span class="js-valide-email-label"></span>');
    if (cEmail != lEmail) {
      $(".js-valide-email-label").text("Not valid email!");
    } else {
      $(".js-valide-email-label").text("");
    }
  });

  //next cta
  $(".js-quick-next-submit").on("click", function () {
    console.log("got this click");
    var required_field_valid = true;
    var product_form = $(this).closest("form");
    const cemail = product_form.find(".js-confirmation-email").val();
    const nemail = product_form.find("#quick-add-modal-form-email").val();
    var cEmailWrap = product_form
      .find(".js-confirmation-email")
      .closest(".quick-add-modal-form-field");

    product_form.find(".js-required-field").each(function () {
      var value = $(this).val();

      if (value != "") {
      } else {
        required_field_valid = false;
        $(this).addClass("not-valid");
      }
    });

    $(".js-valide-email-label").remove();
    cEmailWrap.append('<span class="js-valide-email-label"></span>');
    if (cemail != nemail) {
      required_field_valid = false;
      $(".js-valide-email-label").text("Not valid email!");
    } else {
      $(".js-valide-email-label").text("");
    }

    if (!required_field_valid) return;

    product_form.find('.quick-add-modal--content[data-step="form"]').hide();
    product_form.find('.quick-add-modal--content[data-step="addon"]').show();
  });

  //submit
  $(".js-quick-add-submit").on("click", function () {
    var product_form = $(this).closest("form");
    $(this).closest("form").submit();
    //    product_form.find('.quick-add-modal--content[data-step="addon"]').hide();
    //   product_form.find('.quick-add-modal--content[data-step="thankyou"]').show();
  });

  $(".quick-add-modal__content-info form").on("submit", function (e) {
    e.preventDefault();
    $(
      '.quick-add-modal-form-submit:visible .button.button-small.js-quick-add-submit:not(".button-black")'
    )
      .prop("disabled", true)
      .text("Submitting...");
    console.log("got the form");
    var integro_url = "//hook.us1.make.com/4wtbzamol7edwitpig5dvi2ur2yhlw0c";
    var serializedReturn = $(this).serialize();
    $.ajax({
      type: "POST",
      url: integro_url,
      data: serializedReturn,
      dataType: "json",
      success: function (data) {
        if (data) {
          console.log(data);
          console.log(data.draft_name);
          window.location.href =
            "/pages/thank-you-fdr?name=" +
            data.draft_name +
            "&details=" +
            data.details;
        }
      },
      fail: function (jqXHR, textStatus) {
        console.log(jqXHR + " -- " + textStatus);
        $loadingbtn.removeClass("spinning");
        alert("Process failed, please reload the page and try again");
      },
    });
  });

  //addon updates

  $(".quick-add-modal-form-addon-checkbox").on("click", function () {
    console.log("got the click on addon");
    console.log(
      $(this)
        .parents(".quick-add-modal-form-addon__item")
        .find("input")
        .data("vid")
    );
    $(this).parents(".quick-add-modal-form-addon__item").toggleClass("active");
    var div = $(this).parents(".quick-add-modal-form-addon__item"),
      vid = $(this)
        .parents(".quick-add-modal-form-addon__item")
        .find("input")
        .data("vid");
    if ($(div).hasClass("active")) {
      console.log("has");
      $(div).find("input").val(vid);
    } else {
      console.log("has not");
      $(div).find("input").val("");
    }
  });

  $(".quick-add-modal-form-addon-image").on("click", function () {
    console.log("got the click on addon");
    console.log(
      $(this)
        .parents(".quick-add-modal-form-addon__item")
        .find("input")
        .data("vid")
    );
    $(this).parents(".quick-add-modal-form-addon__item").toggleClass("active");
    var div = $(this).parents(".quick-add-modal-form-addon__item"),
      vid = $(this)
        .parents(".quick-add-modal-form-addon__item")
        .find("input")
        .data("vid");
    if ($(div).hasClass("active")) {
      console.log("has");
      $(div).find("input").val(vid);
    } else {
      console.log("has not");
      $(div).find("input").val("");
    }
  });

  $("#quick-add-modal-form-phone").on("input", function () {
    let text = $(this).val();
    text = text.replace(/\D/g, "");
    text =
      "(" +
      text.substring(0, 3) +
      ") " +
      text.substring(3, 6) +
      "-" +
      text.substring(6, 10);
    $(this).val(text);
  });
});

function initFileUpload() {
  const fileUploadObserver = new MutationObserver((mutationsList, observer) => {
    // Iterate through each mutation
    for (const mutation of mutationsList) {
      // Check if nodes were added to the DOM
      if (mutation.type === "childList") {
        // Check if any added node has the desired class
        const addedNodes = Array.from(mutation.addedNodes);
        const hasFilepondItem = addedNodes.some((node) =>
          node.classList.contains("filepond--item")
        );

        if (hasFilepondItem) {
          // Add the spinner class to the <ul> element
          const ulElement = document.querySelector("ul.filepond--list");
          if (ulElement) {
            $(".filepond--drop-label label i.fa-spinner").remove();
            $(".filepond--drop-label label").append(
              '<i class="fa fa-spinner fa-spin" style=" font-size: 17px; margin-left: 10px; top: 1px; position: relative; "></i>'
            );
            $("button.product-form__submit.button").attr("disabled", true);
            $(".js-quick-next-submit").addClass("disabled");
            $(".js-quick-next-submit").attr("disabled", "disabled");
            console.log("file-uploaded");
            var intervalMatch = setInterval(doStuffCheck, 100);
            function doStuffCheck() {
              console.log("match interval");
              var liLength = $("ul.filepond--list li.filepond--item").length;
              var processedLength = $(
                'ul.filepond--list li.filepond--item[data-filepond-item-state="processing-complete"]'
              ).length;
              if (liLength == processedLength) {
                $("button.product-form__submit.button").attr("disabled", false);

                $(".filepond--drop-label label i.fa-spinner").remove();
                clearInterval(intervalMatch);
                $(".js-quick-next-submit").removeClass("disabled");
                $(".js-quick-next-submit").removeAttr("disabled");
              }
            }
          }
        }
      }
    }
  });
  const targetNode = document.querySelector("ul.filepond--list");
  const config = { childList: true };
  fileUploadObserver.observe(targetNode, config);
}

var intervalCheckFileUpload = setInterval(doStuffUpload, 100);
function doStuffUpload() {
  if ($("ul.filepond--list").length > 0) {
    initFileUpload();
    clearInterval(intervalCheckFileUpload);
  }
}

var c1 = setInterval(function () {
  console.log("interval");
  var imagesCount = $(
    ".customer-submitted-photos-section .stamped-visual-gallery-media-block"
  ).length;
  if (imagesCount == 0 || imagesCount == 1) {
    $(".customer-submitted-photos-section").css("visibility", "hidden");
  } else {
    clearInterval(c1);
    $(".customer-submitted-photos-section").css("visibility", "visible");
  }
  if (imagesCount <= 6) {
    $(".stamped-visual-gallery-nav").hide();
  }
}, 500);

$("document").ready(function () {
  $.urlParam = function (name) {
    var results = new RegExp("[?&]" + name + "=([^&#]*)").exec(
      window.location.search
    );

    return results !== null ? results[1] || 0 : false;
  };

  console.log($.urlParam("name")); //edit
  var name = $.urlParam("name");
  if (name.length > 2) {
    $(".fdrnum").html(name);
  }
});
